exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nextPrev{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.nextPrev,.nextPrev *{cursor:pointer}.nextPrev:not(.reverse)>*+*{margin-left:var(--space-s)}.nextPrev.reverse{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.nextPrev.reverse>*+*{margin-right:var(--space-s)}.nextPrev button{z-index:1}", ""]);

// exports
